import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map, Observable} from "rxjs";
import {jwtDecode} from "jwt-decode";

@Injectable({
  providedIn: 'root'
})
export class AuthService {


  url = 'http://localhost:5007/api/login_check'

  constructor(private http: HttpClient) {
  }

  login(
    username: string | null,
    password: string | null
  ): Observable<Object> {
    return this.http.post(`${environment.apiUrl}/api/login_check`, {username, password})
      .pipe(
        map(response => {
// login successful if there's a jwt token in the response
          if (response) {
            localStorage.setItem('jwt', JSON.stringify(response));
          }

          return response;
        })
      );
  }

  refresh(refreshPayload): Observable<any> {
    return this.http.post(`${environment.apiUrl}/api/token/refresh`, refreshPayload);
  }

  //SSO

  checkAzureTokenInBack(accesToken: string) {
    return this.http.post(`${environment.apiUrl}/auth/sso/token_check`, {'token' : accesToken});
  }
}
